const initialState = {
  getIncidentReportAll: [],
  getGrafikIncident: null,
  getNotifikasi: [],
  getDetailIncidentReport: [],
};
const incidentReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (action.type) {
    case "SET_GETREPORTINCIDENT":
      return {
        ...state,
        getIncidentReportAll: data,
      };
    case "SET_GRAFIKINCIDENT":
      return {
        ...state,
        getGrafikIncident: data,
      };
    case "SET_GETNOTIFIKASI":
      return {
        ...state,
        getNotifikasi: data,
      };
    case "SET_GETDETAILINCIDENTREPORT":
      return {
        ...state,
        getDetailIncidentReport: data,
      };
    default:
      return state;
  }
};
export default incidentReducer;
